import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconScreenshotOutline } from '@saucelabs/ds-icons';

import { GlobalState } from '../../../reducers';
import { TOOLBAR_TRACKING_NAMES, trackEvent } from '../../../tracking';
import { CONFIGURATION_DEVICE_TYPES } from '../../../constants';
import { takeMobileDeviceScreenshot } from '../../../actions';
import {
  operations as liveSessionManagerOperations,
  selectors as liveSessionManagerSelectors,
} from '../../liveSessionManager';
import GenericButton from './GenericButton';
import selectors from '../selectors';

// TODO: remove when liveSessionManager selectors are properly typed
type VirtualSession = {
  isChannelReconnecting: boolean;
  screenshotRetrievalInProgress: boolean;
}

const TakeScreenshotButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    deviceToolsDisabled,
    deviceType,
    testType,
  } = useSelector(selectors.toolbarButtonSelector);
  const {
    isChannelReconnecting,
    screenshotRetrievalInProgress,
  } = useSelector<GlobalState, VirtualSession>(liveSessionManagerSelectors.virtualSessionSelector);
  const isDisabled = (deviceType === CONFIGURATION_DEVICE_TYPES.REAL_DEVICE) ?
    deviceToolsDisabled :
    isChannelReconnecting || screenshotRetrievalInProgress;

  const takeScreenshot = () => {
    if ((deviceType === CONFIGURATION_DEVICE_TYPES.REAL_DEVICE)) {
      void dispatch(takeMobileDeviceScreenshot());
    } else {
      void dispatch(liveSessionManagerOperations.takeScreenshot());
    }

    trackEvent(TOOLBAR_TRACKING_NAMES.SCREENSHOT, { deviceType, testType });
  };

  return (
    <GenericButton
      dataQa="live-session-toolbar-button-take-screenshot"
      disabled={isDisabled}
      icon={IconScreenshotOutline}
      label="Take Screenshot"
      onPress={takeScreenshot}
      role={role}
    />
  );
};

TakeScreenshotButton.displayName = 'TakeScreenshotButton';

export default TakeScreenshotButton;
